import { render, staticRenderFns } from "./FailInformationEmployeeSalary.vue?vue&type=template&id=7b4a2a30&scoped=true"
import script from "./FailInformationEmployeeSalary.vue?vue&type=script&lang=js"
export * from "./FailInformationEmployeeSalary.vue?vue&type=script&lang=js"
import style0 from "./FailInformationEmployeeSalary.vue?vue&type=style&index=0&id=7b4a2a30&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4a2a30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4a2a30')) {
      api.createRecord('7b4a2a30', component.options)
    } else {
      api.reload('7b4a2a30', component.options)
    }
    module.hot.accept("./FailInformationEmployeeSalary.vue?vue&type=template&id=7b4a2a30&scoped=true", function () {
      api.rerender('7b4a2a30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/employeeSalary/employeeSalarySearchDialog/FailInformationEmployeeSalary.vue"
export default component.exports